// Константы для таймаутов и других настроек приложения

// Таймауты для запросов к базе данных (в миллисекундах)
export const TIMEOUTS = {
  // Таймаут для запроса к таблице users (3 секунды)
  USER_QUERY: 3000,
  // Таймаут для запроса в AuthCallback (5 секунд - более либеральный)
  AUTH_CALLBACK_QUERY: 5000,
  // Таймаут для общей загрузки аутентификации (30 секунд - запасной)
  AUTH_LOADING: 30000,
  // Задержка между запросами при синхронизации календаря (200ms)
  CALENDAR_SYNC_DELAY: 200,
  // Задержка при ошибке синхронизации календаря (300ms)
  CALENDAR_SYNC_ERROR_DELAY: 300,
  // Задержка для фонового создания пользователя (100ms)
  BACKGROUND_USER_CREATION: 100,
  // Задержка в AuthCallback для обработки сессии (500ms)
  AUTH_CALLBACK_DELAY: 500,
} as const

